import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { IClientAddReduxProps, IClient, IClientAdd, IClientAddRedux, ITarget } from '../../types/interfaces';

import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { getUsers } from '../../flux/actions/userActions';
import { addClient, checkCINUniqueness, checkPassportUniqueness, searchClients } from '../../flux/actions/clientActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCheckCircle, faCheckSquare, faExternalLinkAlt, faFileImage, faHandRock, faPen, faPlus, faRedo, faSpinner, faSquare, faTimes, faUndo } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import AsyncSelect from 'react-select/async';
import NumberFormat from 'react-number-format';

import DatePicker from "reactstrap-date-picker";
import PhoneInput from "react-phone-input-2";
import frPhoneInput from 'react-phone-input-2/lang/fr.json'
import 'react-phone-input-2/lib/bootstrap.css'

import { useDropzone } from 'react-dropzone';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { constants } from '../../types/constants';
import { getNationality } from '../../services/misc';
// import * as faceapi from "face-api.js";

const ClientAdd = ({
  modal,
  setModal,
  handleToggle,
  addTableClientCallback,
  addClient,
  getUsers,
  user,
  autoSelectUserId,
  projet,
  auth
 }: IClientAdd) => {
  const alert = useAlert();

  const { users, loading: loadingU } = user;
  const userOptions = users.map(e => ({value: e, label: e.username}));
  const [userValue, setUserValue] = useState<any>('');
  const [CINOverPassport, setCINOverPassport] = useState(true);
  const [CINValue, setCIN] = useState('');
  const CINRef = useRef<HTMLInputElement>(document.createElement("input"));
  const [RCValue, setRC] = useState('');
  const [dateCINValue, setDateCIN] = useState('');
  const [passportValue, setPassport] = useState('');
  const passportRef = useRef<HTMLInputElement>(document.createElement("input"));
  // const [civiliteValue, setCivilite] = useState('');
  const civiliteOptions = [{value: "Mme", label: "Madame"}, {value: "Mr", label: "Monsieur"}, {value: "Ste", label: "Société"}];
  const [selectedCivilite, setSelectedCivilite] = useState<any>('');
  const [nomValue, setNom] = useState('');
  const [prenomValue, setPrenom] = useState('');
  const [professionValue, setProfession] = useState('');
  const typeProfessionOptions = ["Salarié", "Fonctionnaire d'état", "Commerçant", "Société / Personne morale", "Sans"].map(e => ({value: e, label: e}));
  const [typeProfession, setTypeProfession] = useState<any>('');
  const [telValue, setTel] = useState<any>('');
  const [tel2Value, setTel2] = useState<any>('');
  const [telIsValid, setTelIsValid] = useState(true);
  const [tel2IsValid, setTel2IsValid] = useState(true);
  const [mailValue, setMail] = useState('');
  const emailSuffixes = ["@gmail.com", "@hotmail.com", "@hotmail.fr", "@yahoo.fr"];
  const [adresseValue, setAdresse] = useState('');
  const [villeValue, setVille] = useState('');
  // const [paysValue, setPays] = useState('');
  const paysOptions = ["Afghanistan", "Afrique du Sud", "Albanie", "Algérie", "Allemagne", "Andorre", "Angola", "Antigua-et-Barbuda", "Arabie saoudite", "Argentine", "Arménie", "Australie", "Autriche", "Azerbaïdjan", "Bahamas", "Bahreïn", "Bangladesh", "Barbade", "Bélarus", "Belgique", "Belize", "Bénin", "Bhoutan", "Bolivie", "Bosnie-Herzégovine", "Botswana", "Brésil", "Brunéi Darussalam", "Bulgarie", "Burkina Faso", "Burundi", "Cambodge", "Cameroun", "Canada", "Cap-Vert", "Chili", "Chine", "Chypre", "Colombie", "Comores", "Congo", "Congo, (République démocratique du) ", "Corée, (République de) ", "Corée, (République populaire démocratique de)", "Costa Rica", "Côte d'Ivoire", "Croatie", "Cuba", "Danemark", "Djibouti", "Dominique", "Egypte", "El Salvador", "Emirats arabes unis", "Equateur", "Erythrée", "Espagne", "Estonie", "Etats-Unis", "Ethiopie", "Fidji", "Finlande", "France", "Gabon", "Gambie", "Géorgie", "Ghana", "Grèce", "Grenade", "Guatemala", "Guinée", "Guinée-Bissau", "Guinée équatoriale", "Guyana", "Haïti", "Honduras", "Hongrie", "Iles Cook", "Iles Marshall", "Iles Salomon", "Inde", "Indonésie", "Iran (République islamique d')", "Iraq", "Irlande", "Islande", "Israël", "Italie", "Jamahiriya arabe libyenne", "Jamaïque", "Japon", "Jordanie", "Kazakhstan", "Kenya", "Kirghizistan", "Kiribati", "Koweït", "l'ex-République yougoslave de Macédoine", "Lesotho", "Lettonie", "Liban", "Libéria", "Liechtenstein", "Lituanie", "Luxembourg", "Madagascar", "Malaisie", "Malawi", "Maldives", "Mali", "Malte", "Maroc", "Maurice", "Mauritanie", "Mexique", "Micronésie, (Etats fédérés de)", "Moldova, (République de)", "Monaco", "Mongolie", "Mozambique", "Myanmar", "Namibie", "Nauru", "Népal", "Nicaragua", "Niger", "Nigéria", "Nioué", "Norvège", "Nouvelle-Zélande", "Oman", "Ouganda", "Ouzbékistan", "Pakistan", "Palaos", "Panama", "Papouasie-Nouvelle Guinée", "Paraguay", "Pays-Bas", "Pérou", "Philippines", "Pologne", "Portugal", "Qatar", "Rép. démocratique populaire lao ", "République centrafricaine", "République dominicaine", "République tchèque", "Roumanie", "Royaume-Uni", "Russie, (Fédération de)", "Rwanda", "Sainte-Lucie", "Saint-Kitts-et-Nevis", "Saint-Marin", "Saint-Siège", "Saint-Vincent-et-Grenadines", "Samoa", "Sao Tomé-et-Principe", "Sénégal", "Serbie-et-Monténégro", "Seychelles", "Sierra Leone", "Singapour ", "Slovaquie", "Slovénie", "Somalie ", "Soudan", "Sri Lanka", "Suède", "Suisse", "Suriname", "Swaziland", "Syrie, (République arabe de)", "Tadjikistan ", "Tanzanie, (République-Unie de)", "Tchad", "Territoire palestinien occupé", "Thaïlande", "Timor-Leste", "Togo", "Tonga", "Trinité-et-Tobago", "Tunisie", "Turkménistan", "Turquie", "Tuvalu", "Ukraine ", "Uruguay", "Vanuatu", "Venezuela", "Viet Nam", "Yémen", "Zambie", "Zimbabwe"].map(e => ({value: e, label: e}));
  const [selectedPays, setSelectedPays] = useState(paysOptions[111]);
  const nationaliteOptions = paysOptions.map(e => ({label: getNationality(e.label), value: e.value}))
  const [selectedNationalite, setSelectedNationalite] = useState<any>(nationaliteOptions[111]);
  const villeOptions = ["AGADIR", "AGADIR DEPOT", "AGLMOUS", "AHFIR", "AIN AOUDA", "AIN ATIQ", "AIN BENI MATHAR", "AIN HARROUDA", "AIN LEUH", "AIN TAOUJDATE", "AIT BAHA", "AIT MELLOUL", "AIT OURIR", "AL ARUIT", "AL HAOUZ", "AL HOCEIMA", "AMSCROUD", "AOUSSERD", "ASILAH", "AZEMMOUR", "AZILAL", "AZROU", "BEJAAD", "BEN AHMED", "BEN GUERIR", "BEN SLIMANE", "BENI ANSAR", "BENI MELLAL", "BERKANE", "BERRECHID", "BIOUGRA", "BIR JDID", "BOUARFA", "BOUDINAR", "BOUFEKRANE", "BOUIZAKARNE", "BOUIZAKARNE", "BOUJAAD", "BOUJDOUR", "BOUKNADEL", "BOULMANE", "BOUMALNE DADES", "BOUSKOURA", "BOUZNIKA", "CABO NEGRO", "CASABLANCA", "CHAOUEN", "CHEFCHAOUEN", "CHEMAIA", "CHICHAOUA", "DAKHLA", "DAR BOUAZZA", "DAR EL GUEDDARI", "DCHEIRA", "DEMNATE", "EL AIOUN", "EL ATTAOUIA", "EL BROUJE", "EL GARA", "EL HAJEB", "EL JADIDA", "EL KALEAA", "EL KSIBA", "EL MHARIS", "EL OUALIDIA", "EL WAHDA / M'JAARA", "ERFOUD", "ERRACHIDIA", "ESSAOUIRA", "FES", "FIGUIG", "FNIDEQ", "FQUIH BEN SALAH", "GOULMIMA", "GOULMIME", "GUEMMASSA", "GUERCIF", "HAD GHOUALEM", "HAD KOURT", "HAD SOUALEM", "HOUARA", "IFNI", "IFRANE", "IMINTANOUT", "IMINTANOUTE", "IMITER", "IMOUZER", "IMZOUREN", "INCONNUE", "INEZGANE", "INZEGANE", "JORF EL MELHA", "JORF LASFAR", "JRADA", "K DES SRAGHNA", "KALAA MGOUNA", "KALAA SRAGHNA", "KARIAT ARAKMANE", "KARIAT BA MED", "KASBA TADLA", "KELAA MGOUNA", "KENITRA", "KHEMISSET", "KHENICHAT", "KHENIFRA", "KHMIS ZEMAMRA", "KHMISS OLAD AYAD", "KHOURIBGA", "KSAR EL KEBIR", "KSAR SEGHIR", "LAAYOUNE", "LARACHE", "M.B KSIRI", "M'RIRT", "MAROC", "MARRAKECH", "MARTIL", "MASSA", "MDIQ", "MEDIOUNA", "MEHDIA", "MEKNES", "MELOUSSA", "MIDELT", "MINE AKKA", "MISSOUR", "MLY BOUSELHAME", "MOHAMMEDIA", "MONTE AROUI", "MY DRISS ZERHOU", "NADOR", "NOUASSER", "OUARZAZATE", "OUAZZANE", "OUED AMLIL", "OUED EDDAHAB", "OUED ZEM", "OUJDA", "OUKAIMDEN", "OULAD AABOU", "OULED ABBOU", "OULED FREJ", "OULED TEIMA", "OULMES", "OUTAT EL HAJ", "PORT KABILA", "PORT MOHAMMEDIA", "PORT NADOR", "PORT TANGER", "RABAT", "RABAT MAGASIN", "RICH", "ROMANI", "ROMMANI", "S. YAHYA GHARB", "S. YAHYA ZEERS", "S.A GHARB", "S.K.S.O.N.", "S/BENNOUR", "SAFI", "SAIDIA", "SALA AL JADIDA", "SALE", "SALE JADIDA", "SEBT EL GUERDANE", "SEFROU", "SEKSAOUA", "SELOUANE", "SETTAT", "SIDI ALLAL AL BAHRAOUI", "SIDI BETTACHE", "SIDI HAJJAJ", "SIDI HRAZEM", "SIDI IFNI", "SIDI KACEM", "SIDI MAAROUF", "SIDI SLIMANE", "SIDI SMAAL", "SKHIRATE", "SKHIRATE-TEMARA", "SMARA", "SOUK EL ARBA DU GHARB", "SOUK SEBT", "SOUK TLET GHARB", "TAFORALT", "TAFRAOUTE", "TAHADDART", "TAHANAOUT", "TAHLA", "TALSINT/ANOUAL", "TAN TAN", "TANGER", "TAOUNAT", "TAOURIRT", "TARFAYA", "TARFAYA", "TARGUIST", "TAROUDANT", "TATA", "TAZA", "TAZNAKHT", "TEMARA", "TETOUAN", "TIFLET", "TIGHZA", "TIKIOUINE", "TINEJDAD", "TINGHIR", "TINRHIRE", "TISSA", "TIT MELLIL", "TIZNIT", "TLAT LOULAD", "YOUSSOUFIA", "ZAG", "ZAGORA", "ZAYOU", "ZENATA", "ZIAO", "AUTRE"].map(e => ({value: e, label: e}));
  const [selectedVille, setSelectedVille] = useState<any>('');
  const [dateNaissValue, setDateNaiss] = useState('');
  const [lieuNaissValue, setLieuNaiss] = useState('');
  const situationOptions = ["MARIE", "DIVORCE", "VEUF", "CELIBATAIRE"].map(e => ({value: e, label: e}));
  const [selectedSituation, setSelectedSituation] = useState<any>('');
  const [nbrEnfValue, setNbrEnf] = useState(0);
  const [nbrEnfFlag, setNbrEnfFlag] = useState(false);
  const nbrEnfRef = useRef<HTMLInputElement>(document.createElement("input"));
  const pubOptions = ["Panneau", "Stand", "Mubaweb", "Avito", "Sarouti.ma", "Facebook", "Instagram", "SMS", "Brochure / Flyer", "Bouche à oreille"].map(e => ({value: e, label: e}));
  const [selectedPub, setSelectedPub] = useState<any>('');
  const [datePubValue, setDatePub] = useState('');
  const [dateVisiteValue, setDateVisite] = useState(new Date().toISOString());
  const [observationValue, setObservation] = useState('');
  const [asyncSelectKey, setAsyncSelectKey] = useState(0);
  const [representedBys, setRepresentedBys] = useState<any>({});
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const [cinppImages, setCinppImages] = useState<any[]>([]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/*',
    multiple: false,
    maxSize: 30000000,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setCinppImages(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      })));
      if(rejectedFiles?.length && rejectedFiles[0].errors){
        if(rejectedFiles[0].errors.find(e => e.code === "file-invalid-type"))
          alert.error("Veuillez sélectionner des fichiers du type Image")
        else if(rejectedFiles[0].errors.find(e => e.code === "file-too-large"))
          alert.error("La taille du fichier est supérieure à 30 Mo")
      }
    }
  });
  const [cinppCrop, setCinppCrop] = useState<any>(null);
  const [cropModal, setCropModal] = useState(false);
  const [disableSubmitCrop, setDisableSubmitCrop] = useState(false);
  const [reEnableCrop, setReEnableCrop] = useState(false);
  const [imgToEdit, setImgToEdit] = useState<any>(null);
  const handleToggleCrop = () => setCropModal(!cropModal);
  const imgRef = useRef<any>(null);
  const previewCanvasRef = useRef<any>(null);
  const [crop, setCrop] = useState({ unit: '%', width: 100, aspect: 86 / 54 });
  const [completedCrop, setCompletedCrop] = useState<any>(null);
  const [isRotating, setIsRotating] = useState(false);

  const cropModalClosedHandle = () => {
    setImgToEdit(null);
    if(reEnableCrop){
      setDisableSubmitCrop(false);
      setReEnableCrop(false);
    }
  };

  // useEffect(() => {
  //   const init = async () => {//TODO: detect rotated images
  //     await faceapi.loadSsdMobilenetv1Model("/models");
  //     await faceapi.loadMtcnnModel("/models");
  //     await faceapi.loadTinyFaceDetectorModel("/models");
  //     // await faceapi.nets.ssdMobilenetv1.loadFromUri("/models");
  //     // await faceapi.nets.faceLandmark68Net.loadFromUri("/models");
  //     // await faceapi.nets.faceRecognitionNet.loadFromUri("/models");
  //     console.log("f-api models Loaded");
  //   }

  //   init()
  // }, [])

  // const [croppedFace, setCroppedFace] = useState('');

  // const detectFace = async () => {
  //   const img = await faceapi.bufferToImage(cinppImages[0]);
  //   let methodUsed = "ssd"
  
  //   let detections = await faceapi.detectAllFaces(img, new faceapi.SsdMobilenetv1Options(/*{ minConfidence: .3 }*/))//.withFaceLandmarks().withFaceDescriptors()
  //   if(!detections?.length){
  //     methodUsed = "mtc"
  //     detections = await faceapi.detectAllFaces(img, new faceapi.MtcnnOptions())
  //   }
  //   if(!detections?.length){
  //     methodUsed = "tiny"
  //     detections = await faceapi.detectAllFaces(img, new faceapi.TinyFaceDetectorOptions())
  //   }
  //   console.log(detections);
    
  //   if(detections?.length){
  //     alert.success(detections.length + " face(s) detected, using " + methodUsed)
  //     const largestDetection = detections.find((e, i, arr) => arr.every(t => (t/*.detection*/["_box"]._width + t["_box"]._height) <= (e["_box"]._width + e["_box"]._height)))
  //     if(largestDetection)
  //       cropFace(img, largestDetection["_box"])
  //   }
  //   else{
  //     alert.info("no face detected")
  //     setCroppedFace('')
  //   }
  // }

  // const cropFace = (img, {_x, _y, _width, _height}) => {
  //   var canvas: any = document.createElement("canvas");                  
  //   canvas.width  = _width * 1.5//zid rb3 f kola terf
  //   canvas.height = _height * 1.5
  //   canvas.getContext("2d").drawImage(img, _x - _width * 0.25, _y - _height * 0.25, img.width, img.height, 0, 0, img.width, img.height);
  //   var base64ImageData = canvas.toDataURL('image/jpg')
  //   console.log(base64ImageData)
  //   setCroppedFace(base64ImageData)
  // }

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    if(!crop || !canvas || !image) return

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext('2d');
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  }, [completedCrop]);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  useEffect(() => {
    autoSetUser();
  }, [users, autoSelectUserId, auth?.user]);

  const modalClosedHandle = () => {
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const CINChangeHandler = (e: ITarget) => setCIN(e.target.value);
  const CINBlurHandler = () => {
    if(!CINValue)
      return
    checkCINUniqueness(CINValue).then(e => {
      if(!e || !e.data){
        alert.error(`N° de la CIN "${CINValue}" déjà saisi dans le système`);
        return
      }
    })
  };
  const RCChangeHandler = (e: ITarget) => setRC(e.target.value);
  const dateCINChangeHandler = (e, t) => {
    setDateCIN(e);
  };
  const passportChangeHandler = (e: ITarget) => setPassport(e.target.value);
  const PassportBlurHandler = () => {
    checkPassportUniqueness(passportValue).then(e => {
      if(!passportValue)
        return
      if(!e || !e.data){
        alert.error(`N° du Passeport "${passportValue}" déjà saisi dans le système`);
        return
      }
    })
  };
  // const civiliteChangeHandler = (e: ITarget) => setCivilite(e.target.value);
  const handleCiviliteChange = data => {
    setSelectedCivilite(data || '');
  }
  const nomChangeHandler = (e: ITarget) => setNom(e.target.value);
  const prenomChangeHandler = (e: ITarget) => setPrenom(e.target.value);
  const professionChangeHandler = (e: ITarget) => setProfession(e.target.value);
  const handleTypeProfessionChange = data => {
    setTypeProfession(data || '');
  }
  const telChangeHandler = (value, t) => setTel({value, t});
  const tel2ChangeHandler = (value, t) => setTel2({value, t});
  const mailChangeHandler = (e: ITarget) => setMail(e.target.value);
  const emailSuffixeHandle = e => {
    setMail(t => `${t}${e}`)
  }
  const adresseChangeHandler = (e: ITarget) => setAdresse(e.target.value);
  const villeChangeHandler = (e: ITarget) => setVille(e.target.value);
  // const paysChangeHandler = (e: ITarget) => setPays(e.target.value);
  const handlePaysChange = data => {
    setSelectedPays(data || '');
  }
  const handleVilleChange = data => {
    setSelectedVille(data || '');
  }
  const dateNaissChangeHandler = (e, t) => {
    setDateNaiss(e);
  };
  const lieuNaissChangeHandler = (e: ITarget) => setLieuNaiss(e.target.value);
  const handleSituationChange = data => {
    setSelectedSituation(data || '');
  }
  const nbrEnfChangeHandler = (e/*: ITarget*/) => {
    const re = /^[0-9\b]+$/;
    if(re.test(e.target.value.toString()) && +e.target.value >= 0)
      setNbrEnf(+e.target.value);
    else if(e.target.value == ""){
      setNbrEnf(0);
      e.target.select();
    }
  };
  const handlePubChange = data => {
    setSelectedPub(data || '');
  }
  const datePubChangeHandler = (e, t) => {
    setDatePub(e);
  };
  const dateVisiteChangeHandler = (e, t) => {
    setDateVisite(e);
  };
  const handleUserChange = data => {
    setUserValue(data ? data.value : '');
  };
  const observationChangeHandler = (e: ITarget) => setObservation(e.target.value);

  useEffect(() => {
    if(CINOverPassport && CINRef.current)
      CINRef.current.focus()
    else if(!CINOverPassport && passportRef.current)
      passportRef.current.focus()
  }, [CINOverPassport]);

  useEffect(() => {
    if(!nbrEnfFlag)
      setNbrEnfFlag(true)
    else if(nbrEnfValue === 0 && nbrEnfRef?.current)
      nbrEnfRef.current.select()
  }, [nbrEnfValue]);

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  const autoSetUser = () => {
    if(users?.length){
      const userTemp = autoSelectUserId !== undefined ? users.find(e => e.id === autoSelectUserId) : auth?.user ? users.find(e => e.id === auth?.user?.id) : null;
      if(userTemp)
        setUserValue(userTemp)
    }
  }

  const rotateImg = (imgUrl: string, degrees: number, setImg: Function) => {
    if(isRotating)
      return
    setIsRotating(true);
    const image = new Image();
    image.src = imgUrl;
    image.onload = function() {
      const canvas = document.createElement("canvas");
      const w = image.width;
      const h = image.height;
      const rads = degrees * Math.PI/180;
      let c = Math.cos(rads);
      let s = Math.sin(rads);
      if (s < 0) { s = -s; }
      if (c < 0) { c = -c; }
      //use translated width and height for new canvas
      canvas.width = h * s + w * c;
      canvas.height = h * c + w * s;
      //draw the rect in the center of the newly sized canvas
      const ctx = canvas.getContext("2d");
      if(ctx){
        ctx.translate(canvas.width/2, canvas.height/2);
        ctx.rotate(degrees * Math.PI / 180);
        ctx.drawImage(image, -image.width/2, -image.height/2);
        setImg(e => ({...e, img: canvas.toDataURL("image/jpeg")}));
        setIsRotating(false);
      }
    };
  }

  const promiseOptions = inputValue =>
    new Promise(resolve => {
      searchClients(inputValue).then(e => 
        resolve(e.map(t => ({label: `${t.NOM} ${t.PRENOM}`, value: t})))
      ).catch(err => resolve([]));
    });
  
  const callback = (success) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success("Client ajouté avec succès");
      if(addTableClientCallback)
        addTableClientCallback(success);
      setCINOverPassport(true);
      setCIN('');
      setRC('');
      setDateCIN('');
      setPassport('');
      setSelectedCivilite('');
      setNom('');
      setPrenom('');
      setProfession('');
      setTypeProfession('');
      setTel('');
      setTel2('');
      setMail('');
      setAdresse('');
      setVille('');
      setSelectedPays(paysOptions[111]);
      setSelectedNationalite(nationaliteOptions[111]);
      setSelectedVille('');
      setDateNaiss('');
      setLieuNaiss('');
      setSelectedSituation('');
      setNbrEnf(0);
      setSelectedPub('');
      setDatePub('');
      setDateVisite(new Date().toISOString());
      setObservation('');
      autoSetUser();
      
      setCinppImages([]);
      setCinppCrop(null);
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const addHandle = async () => {
    if(selectedCivilite === ''){
      alert.error("Veuillez sélectionner la civilité");
      return
    }
    if(CINOverPassport && CINValue === ''){
      alert.error("Veuillez saisir le CIN");
      return
    }
    if(!CINOverPassport && passportValue === ''){
      alert.error("Veuillez saisir le passeport");
      return
    }
    // if(RCValue === ''){
    //   alert.error("Veuillez saisir le RC");
    //   return
    // }
    if(CINOverPassport && selectedCivilite?.value !== "Ste" && dateCINValue === ''){
      alert.error("Veuillez saisir la date de CIN");
      return
    }
    if(!cinppImages?.length){
      alert.error(`Veuillez scanner ${selectedCivilite?.value === "Ste" ? "la fiche RC" : CINOverPassport ? "la CIN" : "le passport"}`);
      return
    }
    if(nomValue === ''){
      alert.error("Veuillez saisir le nom");
      return
    }
    if(prenomValue === '' && selectedCivilite?.value !== "Ste"){
      alert.error("Veuillez saisir le prénom");
      return
    }
    // if(!professionValue){
    //   alert.error("Veuillez saisir la profession");
    //   return
    // }
    if(!typeProfession && selectedCivilite?.value !== "Ste"){
      alert.error("Veuillez sélectionner le type de la profession");
      return
    }
    if(telValue === '' || !telValue.value || telValue.value.length <= 4){
      alert.error("Veuillez saisir le N° de téléphone");
      return
    }
    if(!telIsValid || !tel2IsValid){
      alert.error("N° de téléphone erroné");
      return
    }
    if(adresseValue === ''){
      alert.error("Veuillez saisir l'adresse");
      return
    }
    if(!selectedPays){
      alert.error("Veuillez sélectionner le pays");
      return
    }
    if(!selectedNationalite){
      alert.error("Veuillez sélectionner la nationalité");
      return
    }
    if((selectedPays.value === paysOptions[111].value && selectedVille === '') || (selectedPays.value !== paysOptions[111].value && villeValue === '')){
      alert.error("Veuillez sélectionner la ville");
      return
    }
    if(dateNaissValue === ''){
      alert.error("Veuillez saisir la date de naissance");
      return
    }
    if(!selectedSituation && selectedCivilite?.value !== "Ste"){
      alert.error("Veuillez sélectionner la situation familiale");
      return
    }
    if(!selectedPub){
      alert.error("Veuillez sélectionner le support publicitaire");
      return
    }
    if(!userValue || userValue === ''){
      alert.error("Veuillez sélectionner le commercial");
      return
    }
    
    const representedBysArr = Object.entries(representedBys).map(e => e[1])
    if(selectedCivilite?.value === "Ste"){
      if(!representedBysArr.length){
        alert.error("Veuillez sélectionner les personnes qui représentent la société");
        return
      }
      if(representedBysArr.some((e: any) => !e.client)){
        alert.error("Veuillez sélectionner la personne qui représente la société");
        return
      }
      if(representedBysArr.some((e: any) => !e.job)){
        alert.error("Veuillez saisir le poste");
        return
      }
    }

    setDisableSubmit(true);
    if(CINOverPassport){
      const uniquenessRes = await checkCINUniqueness(CINValue);
      if(!uniquenessRes || !uniquenessRes.data){
        alert.error(`N° de la CIN "${CINValue}" déjà saisi dans le système`);
        setDisableSubmit(false);
        return
      }
    }
    else{
      const uniquenessRes2 = await checkPassportUniqueness(passportValue);
      if(!uniquenessRes2 || !uniquenessRes2.data){
        alert.error(`N° du Passport "${passportValue}" déjà saisi dans le système`);
        setDisableSubmit(false);
        return
      }
    }

    const client : IClient = {
      PROJET: projet?.LIBELE,
      IDPROJET: projet?.id,
      CIN: CINOverPassport ? CINValue : undefined,
      PASSPORT: !CINOverPassport ? passportValue : undefined,
      RC: RCValue,
      CIVILITE: selectedCivilite.value,
      NOM: nomValue,
      PRENOM: prenomValue,
      TEL: telValue?.value ? (telValue.t.dialCode === "212" ? (telValue.value.length > 4 ? ("0" + telValue.value.substr(3)) : "") : telValue.value) : "",
      TEL2: tel2Value?.value ? (tel2Value.t.dialCode === "212" ? (tel2Value.value.length > 4 ? ("0" + tel2Value.value.substr(3)) : "") : tel2Value.value) : "",
      MAIL: mailValue,
      ADRESSE: adresseValue,
      PAYS: selectedPays.value,
      NATIONALITE: selectedNationalite.value,
      VILLE: selectedPays.value === paysOptions[111].value ? selectedVille.value : villeValue,
      PROFESSION: professionValue,
      TYPE_PROFESSION: typeProfession?.value || null,
      DATE_CIN: CINOverPassport && selectedCivilite?.value !== "Ste" ? new Date(dateCINValue) : undefined,
      DATE_NAISS: new Date(dateNaissValue),
      LIEU_NAISS: lieuNaissValue,
      SITUATION_FAM: selectedSituation?.value || null,
      NBR_ENFANT: nbrEnfValue,
      SUPPORT_PUB: selectedPub?.value || null,
      DATE_PUB: new Date(datePubValue),
      DATE_VISITE: new Date(dateVisiteValue),
      COMMERCIAL: userValue.id,
      OBSERVATION: observationValue,
      SAISIE_PAR: auth?.user && auth?.user.username ? auth?.user.username : undefined,
      ID_COM: auth?.user && auth?.user.id ? auth?.user.id : undefined,
    };
    // addClient(client, callback);

    if(cinppImages?.length){
      var reader = new FileReader();
      reader.onload = function() {
        var arrayBuffer = this.result,
          codedBuffer: string = "";
        (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
            codedBuffer += String.fromCharCode(byte);
        });
        addClient(client, selectedCivilite?.value === "Ste" ? representedBysArr : null, {codedBuffer, name: CINOverPassport ? CINValue : passportValue, isCIN: CINOverPassport ? 1 : 0}, callback);
      }
      reader.readAsArrayBuffer(cinppCrop || cinppImages[0]);
    }
    else
      addClient(client, selectedCivilite?.value === "Ste" ? representedBysArr : null, null, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Ajout d'un nouveau Client</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="civilite" className="requiredLabel">Civilité</Label>
                    <Select
                      id="civilite"
                      name="civilite"
                      className="reactselect"
                      classNamePrefix="react-select"
                      // defaultValue={civiliteOptions[0]}
                      value={selectedCivilite}
                      // value={{value: societeValue.value, label: societeValue.label}}
                      onChange={handleCiviliteChange}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={false}
                      options={civiliteOptions}                
                    />
                    {/* <Input id="civilite" placeholder="Civilité..." value={civiliteValue} onChange={civiliteChangeHandler} /> */}
                  </FormGroup>
                </Col>
              </Row>
              {selectedCivilite?.value === "Ste" && <>
                <Label className="requiredLabel">Représenté par</Label>
                {Object.entries(representedBys).map((e: any[], key, arr) => <Container className="CardInfo mb-2" key={key}>
                  <Row style={{padding: 0}}>
                    <Col xs="12" style={{border: "none"}}>
                      <FormGroup style={{marginBottom: '0.3rem'}}>
                        <Label for="client" style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                          Client
                          <FontAwesomeIcon icon={faTimes} style={{color: "red", cursor: arr.length > 1 ? "pointer" : "default", opacity: arr.length > 1 ? 1 : .2}} onClick={() => (arr.length > 1) && setRepresentedBys(e => {
                            const temp = {...e};
                            delete temp[Number(key) + 1];
                            const arrTemp = Object.entries(temp);
                            const res = {};
                            for(let i = 0; i < arrTemp.length; i++)
                              res[i + 1] = arrTemp[i][1]
                            return res
                          })} />
                        </Label>
                        <AsyncSelect
                            id="client"
                            className="reactselect"
                            classNamePrefix="react-select"
                            key={asyncSelectKey}
                            cacheOptions
                            defaultOptions
                            value={e[1].client ? {label: `${e[1].client.NOM} ${e[1].client.PRENOM}`, value: e[1].client} : null}
                            // loadOptions={(e, t) => loadOptions(e, t)}
                            loadOptions={promiseOptions}
                            onChange={t => setRepresentedBys(n => ({...n, [e[0]]: {...n[e[0]], client: t?.value || null}}))}
                            placeholder={'Chercher par nom ou par CIN...'}
                            isClearable={true}
                            loadingMessage={() => 'Chargement...'}
                            noOptionsMessage={() => 'pas de resultat'}
                        />
                        <div className="daAdvancedSearchDiv justify-content-end" style={{margin: 0}}>
                          <span className="daAdvancedSearchBtn" onClick={() => setAsyncSelectKey(e => e + 1)}>Actualiser</span>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row style={{padding: 0}}>
                    <Col xs="12" sm="12" style={{border: "none"}}>
                      <FormGroup>
                        <Label for={`represented_job_${key}`}>Poste</Label>
                        <Input id={`represented_job_${key}`} placeholder="Poste..." value={e[1].job || ''} onChange={t => setRepresentedBys(n => ({...n, [e[0]]: {...n[e[0]], job: t.target.value}}))} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row style={{padding: 0}}>
                    <Col xs="12" sm="12" style={{border: "none"}}>
                      <FormGroup>
                        <Label for={`comment_${key}`}>Commentaire</Label>
                        <Input id={`comment_${key}`} placeholder="Commentaire..." value={e[1].comment || ''} onChange={t => setRepresentedBys(n => ({...n, [e[0]]: {...n[e[0]], comment: t.target.value}}))} />
                      </FormGroup>
                    </Col>
                  </Row>
                </Container>)}
                <div className="fullFlexCenter">
                  <div style={{cursor: "pointer", textDecoration: "underline", fontSize: "small", fontStyle: "italic"}} onClick={() => setRepresentedBys(e => ({...e, [Object.entries(e).length + 1]: {}}))}><FontAwesomeIcon icon={faPen} />&nbsp;Ajouter une autre personne</div>
                </div>
              </>}
              <Row>
                <Col xs="12">
                  <FormGroup>
                    {/* <Label for="CIN">CIN</Label> */}
                    {selectedCivilite?.value !== "Ste" ? <div>
                      <span className={`bienCardRadio${CINOverPassport ? " selectedBCRadio" : ""}`} onClick={() => setCINOverPassport(true)}><FontAwesomeIcon icon={CINOverPassport ? faCheckSquare : faSquare} />&nbsp;CIN</span>{' '}
                      <span className={`bienCardRadio${!CINOverPassport ? " selectedBCRadio" : ""}`} onClick={() => setCINOverPassport(false)}><FontAwesomeIcon icon={!CINOverPassport ? faCheckSquare : faSquare} />&nbsp;Passeport</span>
                      <span className="requiredLabel"></span>
                    </div> : <Label for="CIN">RC</Label>}
                    {selectedCivilite?.value === "Ste" || CINOverPassport ? <Input id="CIN" placeholder="Numéro de la Carte d'Identité Nationale..." innerRef={CINRef} value={CINValue} onChange={CINChangeHandler} onBlur={CINBlurHandler} /> :
                    <Input id="passport" placeholder="Passeport..." innerRef={passportRef} value={passportValue} onChange={passportChangeHandler} onBlur={PassportBlurHandler} />}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label className="requiredLabel">{selectedCivilite?.value === "Ste" ? "Scan de la fiche RC" : CINOverPassport ? "Scan de la CIN" : "Scan du Passeport"}</Label>
                    <section>
                      <div {...getRootProps({className: `dropzone${isDragActive ? " dropzoneHovered" : ""}`})}>
                        <input {...getInputProps()} />
                        {/* <p>Drag 'n' drop some files here, or click to select files</p> */}
                        {cinppImages?.length ? <aside className="thumbContainer">
                          <div className="thumbEdit" onClick={e => (e.stopPropagation(), setImgToEdit({img: cinppImages?.length ? cinppImages[0].preview : null}), setCropModal(true))} title="Modifier le scan"><FontAwesomeIcon icon={faPen} style={{fontSize: "small"}} /></div>
                          <div className="thumbDelete" onClick={e => (e.stopPropagation(), setCinppCrop(null), setCinppImages([]))} title="Supprimer le scan"><FontAwesomeIcon icon={faTimes} style={{fontSize: "small"}} /></div>
                          <div className="thumb" key={cinppImages[0].name}>
                            <div className="thumbInner">
                              <img src={cinppCrop ? cinppCrop.preview : cinppImages[0].preview} className="thumbImg" />
                            </div>
                          </div>
                        </aside> : <span style={{margin: "20px"}}><FontAwesomeIcon icon={faFileImage} /> Choisir ou <FontAwesomeIcon icon={faHandRock} /> déposer {selectedCivilite?.value === "Ste" || CINOverPassport ? "la" : "le"} <span style={{fontWeight: 600}}>{selectedCivilite?.value !== "Ste" ? "fiche" : CINOverPassport ? "CIN" : "Passeport"}</span> ici</span>}
                      </div>
                    </section>
                  </FormGroup>
                </Col>
              </Row>
              {CINOverPassport && selectedCivilite?.value !== "Ste" ? <Row className="fadeAnimation">
                <Col xs="12">
                  <FormGroup>
                    <Label for="dateCIN" className="requiredLabel">Date de CIN</Label>
                    <DatePicker id="dateCIN"
                      value={dateCINValue}
                      invalid={true}
                      dateFormat={constants.DP_DATE_FORMAT}
                      dayLabels={constants.DP_DAYS}
                      monthLabels={constants.DP_MONTHS}
                      weekStartsOn={constants.DP_WEEK_START}
                      onChange={(v,f) => dateCINChangeHandler(v, f)} />
                  </FormGroup>
                </Col>
              </Row> : null}
              {selectedCivilite?.value !== "Ste" && <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="prenom" className="requiredLabel">Prénom</Label>
                    <Input id="prenom" placeholder="Prénom..." value={prenomValue} onChange={prenomChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>}
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="nom" className="requiredLabel">Nom</Label>
                    <Input id="nom" placeholder={selectedCivilite?.value !== "Ste" ? "Nom de famille..." : "Nom de la Société..."} value={nomValue} onChange={nomChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              {selectedCivilite?.value !== "Ste" && <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="profession">Profession</Label>
                    <Input id="profession" placeholder="Profession..." value={professionValue} onChange={professionChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>}
              {selectedCivilite?.value !== "Ste" && <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="typeProfession" className="requiredLabel">Type Profession</Label>
                    <Select
                      id="typeProfession"
                      name="typeProfession"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={typeProfessionOptions[0]}
                      value={typeProfession}
                      onChange={handleTypeProfessionChange}
                      placeholder={'Type Profession...'}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={typeProfessionOptions}                
                    />
                  </FormGroup>
                </Col>
              </Row>}
              {/* <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="tel">N° de Téléphone 1</Label>
                    <Input id="tel" placeholder="Téléphone 1..." value={telValue} onChange={telChangeHandler} />
                  </FormGroup>
                </Col>
              </Row> */}
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="tel" className="requiredLabel">N° de Téléphone 1</Label>
                    <PhoneInput
                      value={telValue?.value || ""}
                      onChange={telChangeHandler}
                      inputProps={{
                        id: "tel",
                        required: true,
                        autoFocus: false
                      }}
                      inputStyle={{width: "100%"}}
                      localization={frPhoneInput}
                      // defaultMask="... .. .. .."
                      masks={{ ma: '... .. .. ..' }}
                      country="ma"
                      preferredCountries={["ma"]}
                      // disableCountryCode={true}
                      countryCodeEditable={false}
                      enableSearch={true}
                      searchPlaceholder="Rechercher..."
                      isValid={(value, country) => {
                        const isValid = country["iso2"] !== "ma" || value.length - country["dialCode"].length === 9 || value.length - country["dialCode"].length === 0;
                        setTelIsValid(isValid);
                        return isValid
                        if (value.match(/12345/)) {
                          return 'Invalid value: '+value+', '+country["name"];
                        } else if (value.match(/1234/)) {
                          return false;
                        } else {
                          return true;
                        }
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="tel2">N° de Téléphone 2</Label>
                    <PhoneInput
                      value={tel2Value?.value || ""}
                      onChange={tel2ChangeHandler}
                      inputProps={{
                        id: "tel2",
                        required: false,
                        autoFocus: false
                      }}
                      inputStyle={{width: "100%"}}
                      localization={frPhoneInput}
                      masks={{ ma: '... .. .. ..' }}
                      country="ma"
                      preferredCountries={["ma"]}
                      countryCodeEditable={false}
                      enableSearch={true}
                      searchPlaceholder="Rechercher..."
                      isValid={(value, country) => {
                        const isValid = country["iso2"] !== "ma" || value.length - country["dialCode"].length === 9 || value.length - country["dialCode"].length === 0;
                        setTel2IsValid(isValid);
                        return isValid
                        // return value.length - country["dialCode"].length === 9 || value.length - country["dialCode"].length === 0
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              {/* <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="tel2">N° de Téléphone 2</Label>
                    <Input id="tel2" placeholder="Téléphone 2..." value={tel2Value} onChange={tel2ChangeHandler} />
                  </FormGroup>
                </Col>
              </Row> */}
              <Row>
                <Col xs="12">
                  <FormGroup style={{position: "relative"}}>
                    <Label for="mail">Email</Label>
                    <Input id="mail" type="email" placeholder="Adresse électronique..." value={mailValue} onChange={mailChangeHandler} />
                    {mailValue !== '' && !mailValue.includes('@') /*!emailSuffixes.find(e => mailValue.toLowerCase().includes(e))*/ ? <Row className="bottomFloatingInputText" style={{marginTop: "3px"}}>
                      {emailSuffixes.map((e, key) => <Col xs="12" md="3" className="bottomFloatingInputTextBtns" onClick={() => emailSuffixeHandle(e)} key={key}>{e}</Col>)}
                    </Row> : null}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="adresse" className="requiredLabel">Adresse</Label>
                    <Input id="adresse" placeholder="Adresse..." value={adresseValue} onChange={adresseChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="pays" className="requiredLabel">Pays</Label>
                    <Select
                      id="pays"
                      name="pays"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={paysOptions[111]}
                      value={selectedPays}
                      onChange={handlePaysChange}
                      placeholder={'Pays...'}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={paysOptions}                
                    />
                    {/* <Input id="pays" placeholder="Pays..." value={paysValue} onChange={paysChangeHandler} /> */}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="ville" className="requiredLabel">Ville</Label>
                    {selectedPays.value === paysOptions[111].value ? <Select
                      id="ville"
                      name="ville"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={villeOptions[0]}
                      value={selectedVille}
                      onChange={handleVilleChange}
                      placeholder={'Ville...'}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={villeOptions}                
                    /> :
                    <Input id="ville" placeholder="Ville..." value={villeValue} onChange={villeChangeHandler} />}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="nationalite" className="requiredLabel">Nationalité</Label>
                    <Select
                      id="nationalite"
                      name="nationalite"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={nationaliteOptions[111]}
                      value={selectedNationalite}
                      onChange={e => setSelectedNationalite(e || '')}
                      placeholder={'Nationalité...'}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={nationaliteOptions}
                    />
                    {/* <Input id="pays" placeholder="Pays..." value={paysValue} onChange={paysChangeHandler} /> */}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="dateNaiss" className="requiredLabel">{selectedCivilite?.value !== "Ste" ? "Date de Naisance" : "Date Immatriculation"}</Label>
                    <DatePicker id="dateNaiss"
                      value={dateNaissValue}
                      dateFormat={constants.DP_DATE_FORMAT}
                      valid={false}
                      dayLabels={constants.DP_DAYS}
                      monthLabels={constants.DP_MONTHS}
                      weekStartsOn={constants.DP_WEEK_START}
                      onChange={(v,f) => dateNaissChangeHandler(v, f)} />
                  </FormGroup>
                </Col>
              </Row>
              {selectedCivilite?.value !== "Ste" && <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="lieuNaiss">Lieu de Naissance</Label>
                    <Input id="lieuNaiss" placeholder="Lieu de Naissance..." value={lieuNaissValue} onChange={lieuNaissChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>}
              {selectedCivilite?.value !== "Ste" && <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="situation" className="requiredLabel">Situation familiale</Label>
                    <Select
                      id="situation"
                      name="situation"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={situationOptions[0]}
                      value={selectedSituation}
                      onChange={handleSituationChange}
                      placeholder={'Situation familiale...'}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={situationOptions}                
                    />
                  </FormGroup>
                </Col>
              </Row>}
              {selectedCivilite?.value !== "Ste" && selectedSituation !== '' && selectedSituation.value !== situationOptions[3].value && <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="nbrEnf">Nombre d'enfants</Label>
                    <Input type="number" id="nbrEnf" placeholder="Nombre d'enfants..." pattern="[0-9]*" className="form-control" innerRef={nbrEnfRef} value={nbrEnfValue} onChange={nbrEnfChangeHandler} onFocus={focusHandler} />
                  </FormGroup>
                </Col>
              </Row>}
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="pub" className="requiredLabel">Support publicitaire</Label>
                    <Select
                      id="pub"
                      name="pub"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={pubOptions[0]}
                      value={selectedPub}
                      onChange={handlePubChange}
                      placeholder={'Support publicitaire...'}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={pubOptions}                
                    />
                  </FormGroup>
                </Col>
              </Row>
              {selectedPub?.value && <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="datePub">Date Publicité</Label>
                    <DatePicker id="datePub"
                      value={datePubValue}
                      dateFormat={constants.DP_DATE_FORMAT}
                      dayLabels={constants.DP_DAYS}
                      monthLabels={constants.DP_MONTHS}
                      weekStartsOn={constants.DP_WEEK_START}
                      onChange={(v,f) => datePubChangeHandler(v, f)} />
                  </FormGroup>
                </Col>
              </Row>}
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="datevisite">Date Visite</Label>
                    <DatePicker id="dateVisite"
                      value={dateVisiteValue}
                      dateFormat={constants.DP_DATE_FORMAT}
                      dayLabels={constants.DP_DAYS}
                      monthLabels={constants.DP_MONTHS}
                      weekStartsOn={constants.DP_WEEK_START}
                      onChange={(v,f) => dateVisiteChangeHandler(v, f)} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="user" className="requiredLabel">Commercial</Label>
                    <Select
                      name="user"
                      className="reactselect"
                      classNamePrefix="react-select"
                      value={userValue ? {label: userValue["username"], value: userValue} : null}
                      onChange={handleUserChange}
                      placeholder={'Chercher par nom...'}
                      isClearable={true}
                      isLoading={loadingU}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      labelKey='name'
                      // valueKey='countryCode'
                      options={userOptions}
                      menuContainerStyle={{ zIndex: 9999999 }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="observation">Observation</Label>
                    <Input id="observation" placeholder="Commentaire..." value={observationValue} onChange={observationChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center stickyBottom">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={addHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Ajouter</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>

      <Modal isOpen={cropModal} toggle={handleToggleCrop} onClosed={cropModalClosedHandle}>
        <ModalHeader toggle={handleToggleCrop}><FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp;Modification du Scan</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer">
            <Row className="linesConfirmationRow justify-content-around">
              <Col xs="11" sm="6">
                <Button
                  className="btn btn-info linesConfirmationBtn fullEllipsis mt-0"
                  onClick={() => rotateImg(imgToEdit.img, -90, setImgToEdit)}><FontAwesomeIcon icon={faUndo} />
                  &nbsp;&nbsp;Faire pivoter vers la gauche
                </Button>
              </Col>
              <Col xs="11" sm="6">
                <Button
                  className="btn btn-info linesConfirmationBtn fullEllipsis mt-0"
                  onClick={() => rotateImg(imgToEdit.img, 90, setImgToEdit)}><FontAwesomeIcon icon={faRedo} />
                  &nbsp;&nbsp;Faire pivoter vers la droite
                </Button>
              </Col>
            </Row>
            <Row className="linesConfirmationRow justify-content-center">
              {imgToEdit?.img && <ReactCrop
                src={imgToEdit.img}
                onImageLoaded={onLoad}
                crop={crop}
                onChange={(c) => setCrop(c)}
                onComplete={(c) => setCompletedCrop(c)}
              />}
            </Row>
            <Row className="linesConfirmationRow justify-content-center">
              <canvas
                ref={previewCanvasRef}
                style={{
                  width: Math.round(completedCrop?.width ?? 0),
                  height: Math.round(completedCrop?.height ?? 0)
                }}
              />
            </Row>
            <Row className="justify-content-center">
              <Col xs="10" md="3">
                <Button
                  className="btn btn-danger linesConfirmationBtn"
                  onClick={() => {
                    setCinppCrop(null)
                    setCropModal(false);
                  }}
                  ><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Initialiser</Button>
              </Col>
              <Col xs="10" md="6">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={() => {
                    if (!completedCrop || !previewCanvasRef || completedCrop.width === 0 || completedCrop.height === 0)
                      return
                    setDisableSubmitCrop(true);
                    
                    previewCanvasRef.current.toBlob(
                      (blob) => {
                        const previewUrl = window.URL.createObjectURL(blob);
                        blob.preview = previewUrl;
                        setCinppCrop(blob);
                        setReEnableCrop(true);
                        setCropModal(false);
                      },
                      'image/jpeg',
                      1
                    );
                  }}
                  disabled={disableSubmitCrop}
                  ><FontAwesomeIcon icon={disableSubmitCrop ? faSpinner : faCheck} className={disableSubmitCrop ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IClientAddReduxProps) => ({
  user: state.user,
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { addClient, getUsers })(ClientAdd);
